import StarterKit from '@tiptap/starter-kit';
import TextStyle from '@tiptap/extension-text-style';
import TextAlign from '@tiptap/extension-text-align';
import FileHandler from 'tiptap-extension-global-drag-handle';

import type { Extensions, FontType } from './types';

export const FileHandlerConfig = FileHandler.configure({
  allowedMimeTypes: ['image/png', 'image/jpeg', 'image/gif', 'image/webp'],
  onDrop: (currentEditor, files, pos) => {
    files.forEach((file) => {
      const fileReader = new FileReader();

      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        currentEditor
          .chain()
          .insertContentAt(pos, {
            type: 'image',
            attrs: {
              src: fileReader.result,
            },
          })
          .focus()
          .run();
      };
    });
  },
  onPaste: (currentEditor, files, htmlContent) => {
    files.forEach((file) => {
      if (htmlContent) {
        // if there is htmlContent, stop manual insertion & let other extensions handle insertion via inputRule
        // you could extract the pasted file from this url string and upload it to a server for example
        return false;
      }

      const fileReader = new FileReader();

      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        currentEditor
          .chain()
          .insertContentAt(currentEditor.state.selection.anchor, {
            type: 'image',
            attrs: {
              src: fileReader.result,
              alt: 'alt',
            },
          })
          .focus()
          .run();
      };
    });
  },
});

export enum tipTapPluginsMode {
  all = 'ALL',
  emailTemplates = 'TEMPLATES',
  lists = 'LISTS',
  text = 'TEXT',
}

export enum tipTapSize {
  medium = 'medium',
  small = 'small',
}

export const TextAlignConfig = TextAlign.configure({
  types: ['heading', 'paragraph', 'image'],
});

export const baseExtensions: Extensions = [
  StarterKit.configure({
    ...{ codeBlock: false, strike: false, blockquote: false, code: false, horizontalRule: false },
  }),
  TextStyle,
];

export const fonts: FontType[] = [
  { key: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { key: 'ArialBlack', value: '"Arial Black", Gadget, sans-serif' },
  { key: 'ComicSansMS', value: '"Comic Sans MS", cursive, sans-serif' },
  { key: 'Impact', value: 'Impact, Charcoal, sans-serif' },
  { key: 'Lucida', value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif' },
  { key: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
  { key: 'TrebuchetMS', value: '"Trebuchet MS", Helvetica, sans-serif' },
  { key: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
];
